import { useState, type ComponentProps, useEffect, useCallback } from 'react'
import { Hash } from 'lucide-react'
import { Input } from '@bpinternal/ui-kit-next'
import { cn } from '~/utils'

type Props = Omit<ComponentProps<typeof Input>, 'onChange'> & {
  onChange?: (color: string) => void
}

export const HexColorInput = ({ value, onChange, ...props }: Props) => {
  const [inputValue, setInputValue] = useState(value || '')
  const escapeChars = useCallback((val: string) => val.replace(/([^0-9A-F]+)/gi, '').substring(0, 6), [])

  useEffect(() => {
    setInputValue(String(value).replace('#', '') || '')
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = escapeChars(e.target.value.trim())

    // Basic validation for hex color format (# followed by 3 or 6 hexadecimal digits)
    const isValidHex = /^#([0-9A-Fa-f]{3}){1,2}$/.test(`#${input}`)

    setInputValue(input.replace('#', ''))
    if (isValidHex) {
      if (onChange) {
        onChange(`#${input}`) // pass the event to parent handler if valid
      }
    }
  }

  return (
    <div className="relative">
      <Hash className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input {...props} value={inputValue} onChange={handleChange} className={cn('pl-8', props.className)} />
    </div>
  )
}
